import styled from 'styled-components';
import { Palette } from 'core/config';
import { Button, CardBody, CardFooter } from 'view/components/common';

export const Introduction : React.FunctionComponent<{ onContinue: () => void }> = ({ onContinue }) =>
{
    return (
        <Container>
            <CardBody>
                <Paragraph>
                    Thank you for sharing your financial information with us!
                </Paragraph>
                <Paragraph>
                    <span>Step 4</span> in obtaining a mortgage from Manzil is to tell us more about your mortgage.
                </Paragraph>
                <Paragraph>
                    Continue when you are ready.
                </Paragraph>
            </CardBody>
            <CardFooter>
                <Button 
                    title="Continue" 
                    type="button" 
                    onClick={onContinue}
                />
            </CardFooter>
        </Container>
    );
};

const Container = styled.div`
  margin-top: 17.5px;
`;

const Paragraph = styled.p`
  padding-top: 6px;

  :first-child {
    padding-top: 15px;
  }
  
  padding-left: 60px;
  padding-right: 60px;
  font: normal normal normal 10px 'SofiaPro-Regular';
  color: ${Palette.BLUE};
  font-weight: 200;

  span {
    font: normal normal normal 10px 'SofiaPro-Bold';
  }

  @media only screen and (min-width: 1300px) {
    font-size: 12px;

    span {
      font-size: 12px;
    }

    a {
      font-size: 12px;
    }
  }

  @media only screen and (min-width: 1900px) {
    font-size: 14px;

    span {
      font-size: 14px;
    }

    a {
      font-size: 14px;
    }
  }
`;